import LoadingButton from '@mui/lab/LoadingButton';
import { styled } from '@mui/material';
import { StyledLoadingButtonProps } from './types';

export const StyledLoadingButton = styled(LoadingButton)<StyledLoadingButtonProps>`
  background: ${({ loading }) =>
    loading ? 'linear-gradient(298.75deg, rgba(239, 239, 241, 0.4) 0%, #DEDDE4 100%)' : ''};
  width: '${({ width }) => (width ? `${width}px` : '')}';
  height: ${({ height }) => (height ? `${height}px` : '')};
  border-radius: 4px;
`;
